import _asyncToGenerator from "F:/bio_link_pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { defineStore } from 'pinia';
import store from '@/store';
import { useUserStore } from '@/store/user';
import { usecommonStore } from '@/store/common';
import TencentCloudChat from '@tencentcloud/chat';
import { genTestUserSig, TUIChatKit } from '../TUIKit';
import router from '@/router';
import { TUIChatService, TUIUserService } from '@tencentcloud/chat-uikit-engine';
import { TUILogin } from '@tencentcloud/tui-core';
export var useTimStore = defineStore('useTimStore', () => {
  var userStore = useUserStore();
  var commonStore = usecommonStore();
  var SDKAppID = process.env.NODE_ENV === 'development' ? 1400828985 : 1400809643; // Your SDKAppID
  var secretKey = process.env.NODE_ENV === 'development' ? '6ebcba463382ceda48e414c7a7b788c93a303bc282121db7e33648e979bb38c0' : '9727b3d1a0e99661ddace255ee6a13a538674597b756805cfc1748f6dcaa2090'; // Your secretKey
  var isLoginIM = ref(false);

  // tim登录
  function BLKTIMLogin() {
    return _BLKTIMLogin.apply(this, arguments);
  } // tim登出
  function _BLKTIMLogin() {
    _BLKTIMLogin = _asyncToGenerator(function* () {
      //进行IM登录之前首先验证token
      if (!localStorage.getItem('token_blk')) {
        // 没有token 跳转登录页
        router.push('/login');
      } else {
        // 验证token是否有效
        userStore.getInfo().then(/*#__PURE__*/function () {
          var _ref = _asyncToGenerator(function* (res) {
            if (res && res.code == 200) {
              var userInfo = res.data.info;
              console.log("userInfo->", userInfo);
              yield TUILogin.login({
                SDKAppID,
                userID: userInfo.name,
                // UserSig 是用户登录即时通信 IM 的密码，其本质是对 UserID 等信息加密后得到的密文。
                // 该方法仅适合本地跑通 Demo 和功能调试，详情请参见 https://cloud.tencent.com/document/product/269/32688
                userSig: genTestUserSig({
                  SDKAppID,
                  secretKey,
                  userID: userInfo.name
                }).userSig,
                // 如果您需要发送图片、语音、视频、文件等富媒体消息，请设置为 true
                useUploadPlugin: true,
                // 本地审核可识别、处理不安全、不适宜的内容，为您的产品体验和业务安全保驾护航
                // 此功能为增值服务，请参考：https://cloud.tencent.com/document/product/269/79139
                // 如果您已购买内容审核服务，开启此功能请设置为 true
                // useProfanityFilterPlugin: false,
                framework: 'vue3'
              }).then(res => {
                console.log("loginIm-success->", res);
                isLoginIM.value = true;
                console.log("isLoginIm-->", isLoginIM.value);
                // const { chat } = TUILogin.getContext()
                // chat.registerPlugin({ 'tim-upload-plugin': TIMUploadPlugin });
                setTimeout(() => {
                  TUIUserService.updateMyProfile({
                    nick: userInfo.name,
                    avatar: userInfo.avatar,
                    profileCustomField: [{
                      key: "Tag_Profile_Custom_ID",
                      value: userInfo.id
                    }, {
                      key: "Tag_Profile_Custom_Email",
                      value: userInfo.email
                    }, {
                      key: "Tag_Profile_Custom_Phone",
                      value: userInfo.phone
                    }]
                  });
                }, 2000);
              }).catch(err => {
                console.error("loginIm-error->", err);
              });
            } else if (res && res.code == 401) {
              router.push('/login');
              localStorage.removeItem('token_blk');
              commonStore.CLEAR_ACTIVE_TAGS();
            } else {
              router.push('/login');
            }
          });
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }()).catch(err => {
          router.push('/login');
        });
      }
    });
    return _BLKTIMLogin.apply(this, arguments);
  }
  function TIMLoginOut() {
    TUILogin.logout();
  }

  //   to:消息接收方的 userID 或 groupID，
  // conversationType：会话类型，取值TencentCloudChat.TYPES.CONV_C2C(端到端会话) 或 TencentCloudChat.TYPES.CONV_GROUP  
  // type：自定义常量
  // extension:消息内容 json字符串格式

  function TIMSendCustomMessage(to, type, extension, conversationType, description) {
    var options = {
      to: to,
      conversationType: conversationType ? conversationType : TencentCloudChat.TYPES.CONV_GROUP,
      payload: {
        data: type,
        description: description,
        extension: extension
      }
    };
    return new Promise((resolve, reject) => {
      TUIChatService.sendCustomMessage(options).then(res => {
        console.log('im发送成功->', res);
        resolve('success');
      }).catch(err => {
        console.warn('im发送失败->', err);
        reject('error');
      });
    });
  }
  var keyword = '';
  return {
    isLoginIM,
    SDKAppID,
    secretKey,
    BLKTIMLogin,
    TIMLoginOut,
    TIMSendCustomMessage,
    keyword
  };
});

// 非setup
export function useTimStoreHook() {
  return useTimStore(store);
}